import * as Sentry from "@sentry/browser";

import { User } from "../../user/user.model";

export function setSentryUser(user: User): void {
  const scope = Sentry.getCurrentScope();
  scope.setUser({
    email: user.getEmail(),
    id: user.getId().toString(),
  });

  const organization = user.organization;
  if (organization) {
    scope.setTags({
      "organization.id": organization.getId(),
      "organization.name": organization.getName(),
    });
  }
}
